<form [formGroup]="gameCollectForm" class="objects-form" style="height:auto; overflow-y: auto;">
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.gameCollectForm.name' | translate}}</mat-label>
        <input formControlName="name" matInput type="text" required>
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.gameCollectForm.comment' | translate}}</mat-label>
        <textarea formControlName="comment" matInput type="text"></textarea>
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.gameCollectForm.huntingDistrict' | translate}}</mat-label>
        <mat-select formControlName="huntingDistrict">
            <mat-option *ngFor="let district of dropdownDataHuntingDistricts" [value]="district">{{district.name}}</mat-option>
        </mat-select>
    </mat-form-field>

</form>

<div class="sticky-bottom">
    <button [disabled]="gameCollectForm.invalid" class="first-btn w-100 my-1" mat-raised-button type="submit" (click)="onSubmit()">
        {{ 'FORM.BTN_SAVE' | translate }}
    </button>

    <button id="deleteBTN" [disabled]="gameCollectForm.invalid" class="second-btn w-100" mat-button type="submit" (click)="onDelete()">
        {{ 'FORM.BTN_DELETE' | translate }}
    </button>
</div>
<ng-template injectComp></ng-template>

